import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as ToastActions from "./toast.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { EMPTY, mergeMap, of, tap } from "rxjs";
import { AuthService } from "../../../features/auth/services/auth.service";
import { SocialAuthService } from "@abacritt/angularx-social-login";
import { MessageService } from "primeng/api";
import { ErrorCodeService } from "../../services/error-code.service";

@Injectable()
export class ToastEffects {

  constructor(
    private actions$: Actions,
    private messageService: MessageService,
    private errorCodeService: ErrorCodeService,
  ) {}

  showErrorToast$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ToastActions.showErrorToast),
      switchMap(({ error, cause, context }) => {
        // Every error toast is a failure the user ran into, so every one of them is worth an issue
        // and a reference. Formatting here rather than at the ~19 dispatch sites means nothing has
        // to be remembered when a new one is added. The reference is appended inline rather than
        // rendered with a copy button: a toast is dismissed in a few seconds, so it is something a
        // user screenshots or retypes, not something they get time to click.
        const detail = this.errorCodeService.formatErrorForDisplay(error, {
          cause,
          context,
          tags: { surface: 'error-toast' },
        });

        this.messageService.add({severity: 'error', summary: $localize `Error`, detail});

        return EMPTY;
      })
    ), { dispatch: false }
  );
}

